/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';

const QuitButton = () => (
  <div className="boxBtn-inner">
    <svg className={`shape shape-power-off`}>
      <use xlinkHref={`#shape-power-off`}></use>
    </svg>
  </div>
);

export default QuitButton;



// WEBPACK FOOTER //
// ./src/browser/components/buttons/QuitButton.js